import { useEffect, useState } from 'react'

export function usePeriodicRefetch(
  poll: boolean,
  refetch: () => void,
  interval: number = 30_000
) {
  const [, setHandle] = useState<number>(0)

  useEffect(() => {
    poll && setHandle(handle => {
      handle && window.clearInterval(handle)

      return window.setInterval(() => {
        try {
          refetch()
        }
        catch (err) {
          console.warn(err)
        }
      }, interval)
    })

    return () => setHandle(handle => {
      handle && window.clearInterval(handle)
      return 0
    })
  }, [
    interval,
    poll,
    refetch,
    setHandle,
  ])
}
